import AuthUITemplate from "./AuthUI";
import Button from "../../components/common/Button";
import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useActivate } from "react-redux-django-auth";
import useAuthRedirect from "../../hooks/useAuthRedirect";
import { useToast } from "../../hooks/otherHooks/useToast";

const ActivateAccount = () => {
    const { uid } = useParams();
    const { token } = useParams();

    const { error, loading, onSubmit, isStatus204 } = useActivate(
        uid,
        token
    );

    // Toast
    const { showToast, redirectPage } = useAuthRedirect(isStatus204);

    const { addToast } = useToast();

    useEffect(() => {
        if (showToast) {
            addToast({
                message: "Account Activated. Redirecting...",
                bg: "success",
            });
        }
    }, [showToast, addToast]);

    if (redirectPage) {
        return <Navigate to="/login" />;
    }

    return (
        <AuthUITemplate title="Activate your Account" errorMsg={error}>
            <div className="cht-w-full">
                <Button
                    onClick={onSubmit}
                    type="submit"
                    variant="primary"
                    size="lg"
                    fullWidth
                    isLoading={loading}
                    disabled={loading}
                    className="cht-w-full cht-py-4 cht-uppercase cht-tracking-widest cht-text-xs cht-rounded-2xl"
                >
                    Click here to Verify your Account
                </Button>
            </div>
        </AuthUITemplate>
    );
};

export default ActivateAccount;
